/**
 * Converts an 8-bit array into a hex string.
 * @param {Uint8Array} buffer Bit array to convert
 * @return {string} The hex string representation of the bits in buffer.
 */
export const uintArrayToHex = (buffer: Uint8Array): string =>
  Array.from(buffer)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .toLowerCase();

/**
 * Returns a basic hash code from a string
 * @param  {String} str The string to hash.
 * @return {string}  A 32bit integer represented in hex
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
export const javaHash = (str: string) => {
  // "Hash" the incoming string
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const chr = str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line no-bitwise
    hash |= 0; // Convert to 32bit integer
  }
  // Then convert the hash to a hex string so it looks pseudo-legit
  const outputBuffer = new Uint8Array(new BigUint64Array([BigInt(hash)]).buffer);
  return uintArrayToHex(outputBuffer);
};
